import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IWithPrintPDFComponentProps } from 'HOC/withPrintPDF';
import CroptimizerBoard from 'features/Croptimizer/screen/1Board/Board';
import CropRotation from 'features/Croptimizer/screen/3CropRotation/CropRotation';
import SupplyPlan from 'features/Croptimizer/screen/4SupplyPlan';
import Synthesis from 'features/Croptimizer/screen/5Synthesis';
import FiveYearsBoard from 'features/Croptimizer/screen/2Strategy/FiveYearsBoard';
import {
  tabArr, essentialSteps, expertSteps,
} from 'features/Croptimizer/utils/constants';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';
import { BoardSteps } from 'utils/constants';

export interface Props {
  [key: string]: any;
}

const getPDFTitle = (activeTab: number, step: BoardSteps, isExpertMode: boolean) => {
  if (activeTab === 1) {
    // Board tab - get title based on step
    const steps = isExpertMode ? expertSteps : essentialSteps;
    const stepConfig = steps.find(s => s.id === 1 && s.boardStep === step);

    return stepConfig?.title || 'Board';
  } else if (activeTab === 2) {
    return 'Vue 5 ans';
  }
  
  // Fallback to tab title
  return tabArr.find((tab) => tab.id === activeTab)?.title || '';
};

export const PDFCroptimizerContent: FC<Props & IWithPrintPDFComponentProps> = ({
  isPDF,
}) => {
  const { activeTab, step, isExpertMode } = useCroptimizer();
  const { t } = useTranslation();
  
  const pdfTitle = getPDFTitle(activeTab, step, isExpertMode);

  const renderContent = () => {
    switch (activeTab) {
      case 1:
        return <CroptimizerBoard isPDF={isPDF} />;
      case 2:
        return <FiveYearsBoard isPDF={isPDF} />;
      case 3:
        return <CropRotation isPDF={isPDF} />;
      case 4:
        return <SupplyPlan isPDF={isPDF} />;
      case 5:
        return <Synthesis isPDF={isPDF} />;
    }
  };

  return (
    <table>
      <thead>
        <tr>
          <th className="border-none">
            <div className="flex justify-center mb-4">
              <div className={'font-bold text-center text-xl text-black'}>
                {pdfTitle}
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border-none">
            {renderContent()}

            <div className="p-[32px]">
              <div className="text-black font-bold md:text-lg mt-6 mb-8">
                {t('warning')}
              </div>
              <div>{t('warningText')}</div>
              <div className="text-black font-bold md:text-lg mt-6 mb-8">
                {t('disclaimer')}
              </div>
              <div>{t('disclaimerText')}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
